import { gql } from "@apollo/client";
const GET_ANALYTICS_STATS = gql`
  query getServicesDashboard($data: ServiceStatsInput!) {
    getServiceStats(data: $data) {
      status
      data {
        id
        name
        totalCount
        revenue
      }
    }
  }
`;
const GET_EMPLOYEES = gql`
  query getEmployeeList($data: EmployeeFilterInput) {
    getEmployeelist(data: $data) {
      employee {
        id
        fullName
      }
    }
  }
`;
export { GET_ANALYTICS_STATS, GET_EMPLOYEES };
